import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoSizeComponent } from './photo-size.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PhotoSizeComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class PhotoSizeModule { }
